import React, { useEffect, useState } from "react";
import FormComponent from "../../../../../components/gernerateForm/FormComponent";
import generateForm03 from "../data/form03.data";

type Props = {
  onSubmit: (value: any) => void;
  isValidateForm: boolean;
  data: any;
  setData: (value: any) => void;
  mainInputValue: any;
  isValudateFile: boolean;
  isCanEdit?: boolean | true;
};
const Form03: React.FC<Props> = (props: Props) => {
  const {
    onSubmit,
    isValidateForm,
    data,
    setData,
    mainInputValue,
    isValudateFile,
    isCanEdit,
  } = props;

  const [inputValueFormLeave03, setInputValueFormLeave03] = useState({
    information: {
      university_no_ref: "",
      university_date_ref: "",
      ordination_address: "",
      ordination_date: "",
      ordination_province: "",
      ordination_district: "",
      ordination_district_sub: "",
      buddhist_lent_at: "",
      buddhist_lent_province: "",
      buddhist_lent_district: "",
      buddhist_lent_district_sub: "",
    },
  });

  useEffect(() => {
    const information = mainInputValue.information;
    const condition = inputValueFormLeave03.information;

    setData({
      main: information,
      condition: condition,
    });
  }, [inputValueFormLeave03]);

  useEffect(() => {
    if (data?.condition) {
      setInputValueFormLeave03({
        information: data.condition,
      });
    }
  }, []);

  return (
    <FormComponent
      formGenerate={generateForm03}
      inputValue={inputValueFormLeave03}
      setInputValue={setInputValueFormLeave03}
      handleCheckValid={isValidateForm}
      isCanEdit={isCanEdit ?? true}
      permission={"admin"}
    />
  );
};

export default Form03;
